// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUY_BUTTON_USED_STROLLERS = "Pozri nab\u00eddku ojet\u00fdch ko\u010d\u00e1rk\u016f";
export const BUY_IN_ESHOP = "Koupit v eshopu ";
export const GREAT_SET = "V\u00ddHODN\u00dd SET";
export const ORIGINAL_PRICE = "D\u0159\u00edve ";
export const SHOPPING_WITH_MK = "Nakupuj s Modr\u00fdm kon\u00edkem";
export const YOU_SAVE = "U\u0161et\u0159\u00ed\u0161";
